import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import momentJalaali from 'moment-jalaali';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({
  selector: 'Services',

  templateUrl: './services.component.html',
})
export class ServicesComponent implements OnInit {
  constructor(
    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private _location: Location,

    private gurdService: GurdServiceService,
  ) {}

  Id: number = 0;

  Service: any;

  ServiceTxt: any;

  ServiceTxt2: any;

  EditeMod: boolean = false;

  dateInp: boolean = false;

  KmInp: boolean = false;

  loggedInUser: any = this.gurdService.decrypt(
    localStorage.getItem('FullName')!,
  );

  plateNo: any = this.gurdService.decrypt(localStorage.getItem('plate')!);

  vehicle: any = {
    owner: this.gurdService.decrypt(localStorage.getItem('carName')!),
    plate: this.plateNo.split(',').join().replaceAll(',', ' '),
    company: this.gurdService.decrypt(localStorage.getItem('hze')!),
  };

  datasabt: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  serchModel: FormGroup = this.formBuilder.group({
    reson: new FormControl(),
    repairer: new FormControl(),
  });

  sabtModel: FormGroup = this.formBuilder.group({
    iRepairMaintenanceSubject: new FormControl(),

    iRepairMaintenanceCondition: new FormControl(),

    tiMaintenanceMaturity: new FormControl(),

    strComment: new FormControl(''),

    iKM: new FormControl(),

    iWorkHours: new FormControl(),

    iDurationOfOperation: new FormControl(),
  });

  ngOnInit(): void {
    $('#exampleModal').on('hidden.bs.modal', () => {
      this.sabtModel.reset({
        iRepairMaintenanceSubject: 12,
        tiMaintenanceMaturity: 3,
        strComment: '',
      });
      this.datasabt.reset({
        date: momentJalaali().format('jYYYY/jMM/jDD'),
      });
      this.KmInp = false;
      this.dateInp = false;
      this.EditeMod = false;
      this.close();
    });

    this.route.params.subscribe((params) => {
      this.Id = params['id'];
      // this.sabtModel.controls['strUnitId'].setValue(this.Id);
    });

    this.getAllService();

    this.getOption();
  }

  goBack() {
    this._location.back();
  }

  getOption = async () => {
    const resp2 = await axios.post(`MaintenanceMaturity`);

    this.ServiceTxt = resp2.data;

    const resp3 = await axios.post(`RepairMaintenanceSubject`);

    this.ServiceTxt2 = resp3.data;

    this.sabtModel.controls['iRepairMaintenanceSubject'].setValue(12);

    this.sabtModel.controls['tiMaintenanceMaturity'].setValue(3);
  };

  getAllService = async () => {
    this.otherService.Showspinner();

    const session = encodeURIComponent(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    );

    const resp = await axios.post(
      `GetRepairMaintenanceCondition?strUnitID=${this.Id}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
    );

    this.otherService.nonespinner();

    if (resp.data[0] && resp.data[0].ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }

    if (resp.data.length == 0) {
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
      this.Service = resp.data;
    } else {
      this.Service = resp.data;
    }
  };

  sabt = async () => {
    var model = this.sabtModel.value;

    model.strDate = this.datasabt.value.date;

    model.strUnitId = this.Id;

    switch (parseInt(model.tiMaintenanceMaturity)) {
      case 1:
        model.iKM = 0;
        break;
      case 0:
        model.strDate = '';
        break;
      case 2:
        break;
      default:
        model.strDate = '';
        model.iKM = 0;
        break;
    }

    if (
      model.tiMaintenanceMaturity == '0' &&
      (model.iKM == '' || model.iKM == 0 || model.iKM == null)
    ) {
      this.notifyService.showError('لطفا مقدار کیلومتر را وارد کنید');

      return;
    }

    if (
      model.tiMaintenanceMaturity == '2' &&
      (model.iKM == '' || model.iKM == 0 || model.iKM == null)
    ) {
      this.notifyService.showError('لطفا مقدار کیلومتر را وارد کنید');
      return;
    }

    if (model.tiMaintenanceMaturity == '1' && model.strDate == '') {
      this.notifyService.showError('لطفا مقدار زمان را وارد کنید');
      return;
    }

    if (model.iKM != null && model.iKM != '' && model.iKM != 0) {
      model.iKM = model.iKM.replace(/,(?=\d{3})/g, '');
    }

    if (
      model.tiMaintenanceMaturity == '5' &&
      (model.iWorkHours == '' ||
        model.iWorkHours == 0 ||
        model.iWorkHours == null)
    ) {
      this.notifyService.showError('لطفا ساعت خودرو را وارد کنید');

      return;
    }

    if (model.tiMaintenanceMaturity == '5') {
      model.iWorkHours = model.iWorkHours.replace(/,/g, '');
    }

    $.confirm({
      title: `آیا از ثبت اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'green',

      buttons: {
        ok: {
          text: 'ثبت',

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {
            const session = encodeURIComponent(
              this.gurdService.decrypt(window.localStorage.getItem('Session')!),
            );

            const resp = await axios.post(
              `SaveRepairMaintenanceCondition?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
              this.otherService.stringNumberToNumber(model),
            );

            if (resp.data == -100) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['/login']);
              this.router.navigate(['/login'], {
                queryParams: { ERR_CODE: 4 },
              });
              return;
            }

            if (resp.data == -1) {
              this.notifyService.showError('خطایی رخ داده');
            }

            if (resp.data == -2) {
              this.notifyService.showError('این سرویس قبلا ثبت شده');
            }

            if (resp.data == 1) {
              this.notifyService.showSuccess('با موفقیت ثبت شد');
              this.getAllService();
              $('#exampleModal').modal('hide');
            }
          },
        },

        cancel: {
          text: 'لغو',
        },
      },
    });
  };

  getSingel = async (Id: any) => {
    // console.log(this.Service[Id])

    this.datasabt.controls['date'].setValue(this.Service[Id].strDate);

    this.sabtModel.controls['tiMaintenanceMaturity'].setValue(
      this.Service[Id].tiMaintenanceMaturity,
    );

    this.sabtModel.controls['strComment'].setValue(this.Service[Id].strComment);

    this.sabtModel.controls['iRepairMaintenanceCondition'].setValue(
      this.Service[Id].iRepairMaintenanceCondition,
    );

    this.sabtModel.controls['iRepairMaintenanceSubject'].setValue(
      this.Service[Id].iRepairMaintenanceSubject,
    );

    this.sabtModel.controls['iWorkHours'].setValue(this.Service[Id].iWorkHours);

    this.sabtModel.controls['iKM'].setValue(
      this.Service[Id].iKM.toString().replace(/,/g, ''),
    );

    this.handelInp(this.Service[Id].tiMaintenanceMaturity);

    $('#exampleModal').modal('show');

    this.EditeMod = true;
  };

  edit = async () => {
    var model = this.sabtModel.value;
    model.strDate = this.datasabt.value.date;
    model.strUnitId = this.Id;
    switch (parseInt(model.tiMaintenanceMaturity)) {
      case 1:
        model.iKM = 0;
        break;
      case 0:
        model.strDate = '';
        break;
      case 2:
        break;
      default:
        model.strDate = '';
        model.iKM = 0;
        break;
    }
    if (
      model.tiMaintenanceMaturity == '0' &&
      (model.iKM == '' || model.iKM == 0 || model.iKM == null)
    ) {
      this.notifyService.showError('لطفا مقدار کیلومتر را وارد کنید');
      return;
    }

    if (
      model.tiMaintenanceMaturity == '2' &&
      (model.iKM == '' || model.iKM == 0 || model.iKM == null)
    ) {
      this.notifyService.showError('لطفا مقدار کیلومتر را وارد کنید');
      return;
    }
    if (model.tiMaintenanceMaturity == '1' && model.strDate == '') {
      this.notifyService.showError('لطفا مقدار زمان را وارد کنید');
      return;
    }
    if (model.iKM != null && model.iKM != '' && model.iKM != 0) {
      model.iKM = parseFloat(model.iKM.replace(/,/g, ''));
    }
    if (confirm('آیا از ویرایش اطلاعات اطمینان دارید؟')) {
      const session = encodeURIComponent(
        this.gurdService.decrypt(window.localStorage.getItem('Session')!),
      );
      const resp = await axios.post(
        `UpdateRepairMaintenanceCondition?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
        model,
      );
      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        // this.router.navigate(['/login']);
        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 5 } });
        return;
      }
      if (resp.data == -1) {
        this.notifyService.showError('خطایی رخ داده');
        this.sabtModel.reset();
      }
      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت ثبت شد');
        this.getAllService();
        $('#exampleModal').modal('hide');
      }
    }
  };

  deleteService = async () => {
    if (confirm('آیا از حذف اطلاعات اطمینان دارید؟')) {
      var Id = this.sabtModel.value.iRepairMaintenanceCondition;

      const session = encodeURIComponent(
        this.gurdService.decrypt(window.localStorage.getItem('Session')!),
      );

      const resp = await axios.post(
        `DeleteRepairMaintenanceCondition?iRepairMaintenanceCondition=${Id}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
      );
      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        // this.router.navigate(['/login']);
        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 6 } });
        return;
      }
      if (resp.data == 0) {
        this.notifyService.showError('خطایی رخ داده');
      }
      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت حذف شد');
        $('#exampleModal').modal('hide');

        this.Service = this.Service.filter(function (el: any) {
          return el.iRepairMaintenanceCondition != Id;
        });
      }
    }
  };

  seprator(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    this.otherService.insertComma(e);
    return true;
  }

  handelInp(data: any) {
    switch (data) {
      case 2:
        this.KmInp = true;
        this.dateInp = true;
        break;
      case 1:
        this.KmInp = false;
        this.dateInp = true;
        break;
      case 0:
        this.KmInp = true;
        this.dateInp = false;
        break;
      default:
        this.KmInp = false;
        this.dateInp = false;
        break;
    }
  }

  handelselect(e: any) {
    this.handelInp(parseInt(e.target.value));
  }

  close() {
    this.sabtModel.reset({
      iRepairMaintenanceSubject: 12,
      tiMaintenanceMaturity: 3,
      strComment: '',
    });
    this.datasabt.reset({
      date: momentJalaali().format('jYYYY/jMM/jDD'),
    });
    this.KmInp = false;
    this.dateInp = false;
    this.EditeMod = false;
  }

  open() {
    this.close();
  }

  guid(Id: any) {
    this.otherService.guid(Id);
  }
}
